import { actions as postActions } from './posts';
import { actions as commentsActions } from './comments';

export { postActions, commentsActions };
